import { Locale } from '@/utility/locale';
import { post } from '@/utility/requestHelpers/clientRequestHelpers';
import { getSprdAuthHeader } from './requestHelpers/auth';

type EmbroideryPrecheckResult = {
  embroiderySupported: boolean;
};

export type EmbroideryPreviewResult = {
  productKey: string;
};

export type EmbroideryPersistResult = EmbroideryPreviewResult & {
  productId: string;
};

export type EmbroideryPriceResult = {
  price: number;
};

export const precheckEmbroidery = async (
  config: PublicApiConfig,
  vpString: string
): Promise<boolean> => {
  const url = config.decorationServiceUrl + '/precheck';
  const authHeader = await getSprdAuthHeader('POST', url, config.sprdApiKey, config.sprdApiSecret);
  const check = await post<EmbroideryPrecheckResult>(url, vpString, {
    headers: {
      Authorization: authHeader,
    },
  });

  return check.embroiderySupported;
};

export const previewEmbroidery = async (
  config: PublicApiConfig,
  vpString: string
): Promise<EmbroideryPreviewResult> => {
  const url = config.decorationServiceUrl + '/preview';
  const authHeader = await getSprdAuthHeader('POST', url, config.sprdApiKey, config.sprdApiSecret);
  return await post<EmbroideryPreviewResult>(url, vpString, {
    headers: {
      Authorization: authHeader,
    },
  });
};

export const persistEmbroidery = async (
  config: PublicApiConfig,
  productKey: string,
  appearanceId: string
): Promise<EmbroideryPersistResult> => {
  const url = config.decorationServiceUrl + '/persist?appearanceId=' + appearanceId;
  const authHeader = await getSprdAuthHeader('POST', url, config.sprdApiKey, config.sprdApiSecret);
  return await post<EmbroideryPersistResult>(url, productKey, {
    headers: {
      Authorization: authHeader,
    },
  });
};

export const getEmbroideryPrice = async (params: {
  locale: Locale;
  partnerId: string;
  productTypeId: string;
  sellable: Pick<Sellable, 'printAreas'>;
}): Promise<EmbroideryPriceResult> => {
  return await post<EmbroideryPriceResult>('/internal/api/embroideryPrice', params);
};
